import { CollectSessionType } from './types'

interface CollectSessionProps {
  collect_session: CollectSessionType
}

export default function CollectSession({ collect_session }: CollectSessionProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Communauté :</strong>
        {collect_session.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Terminal :</strong>
        {collect_session.device_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Utilisateur :</strong>
        {collect_session.user_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Début :</strong>
        {collect_session.start_at?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Fin :</strong>
        {collect_session.end_at?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Montant physique collecté :</strong>
        {collect_session.physical_amount_collected?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Statut :</strong>
        {collect_session.status?.toString()}
      </p>
    </div>
  )
}
